// = Libs =
import { FC } from 'react';
import { IconProps } from '@/common/components/icons/icon.types';

// = Constants =
import COLORS from '@/constants/colors';

const PhoneIcon: FC<IconProps> = ({ color = 'dark' }) => {
  const iconColor = COLORS[color];

  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.4723 21.2062V24.8669C27.4751 25.5541 27.1857 26.2106 26.6751 26.6752C26.1644 27.1397 25.48 27.3693 24.7898 27.3074C21.0034 26.8994 17.3662 25.6163 14.1706 23.5613C11.1975 21.6878 8.67686 19.1881 6.78763 16.2398C4.70806 13.0564 3.4139 9.43203 3.01 5.66026C2.94782 4.97798 3.17768 4.30121 3.64342 3.79526C4.10915 3.28931 4.76788 3.00077 5.45869 3.00012H9.15019C10.3854 2.98806 11.4383 3.88598 11.6112 5.09894C11.767 6.27046 12.056 7.42074 12.4725 8.52783C12.8106 9.41968 12.5944 10.4251 11.9188 11.1026L10.3561 12.6523C12.1078 15.7072 14.6585 18.2367 17.7391 19.9737L19.3018 18.424C19.985 17.7541 20.9988 17.5397 21.8982 17.8749C23.0146 18.288 24.1745 18.5746 25.3559 18.7291C26.5932 18.9022 27.5033 19.9674 27.4723 21.2062Z"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PhoneIcon;
